import Vue from 'vue'

import { ButtonComponent, setup as ButtonSetup } from 'vue-elder-button'
ButtonSetup({
	type: 'button',
	labels: {
		loading: 'Laster' + '...',
		error: 'Noe gikk galt',
		confirm: 'Er du sikker?',
		success: 'Fullført',
	},
})
Vue.component('ButtonComponent', ButtonComponent)

import { setup as LoaderSetup, LoaderComponent as Loader } from 'vue-elder-loader'
LoaderSetup({
	theme: 'overlay',

	messages: {
		loading: 'Laster' + '...',
		error: 'Noe gikk galt' + '...',
	},
	delay: 200,
})
Vue.component('Loader', Loader)

import InputComponent from '@/components/InputComponent'
Vue.component('InputComponent', InputComponent)
